import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EditorialList } from '~app/modules/storyblok/models/storyblok-global-content.model';
import { EditorialLinkNavigationClickApplicationEvent } from '~shared/modules/application-event/models/editorial-link-navigation-click-event.model';
import { ApplicationEventService } from '~shared/modules/application-event/services';

@Component({
  selector: 'app-editorial-link-list',
  templateUrl: './editorial-link-list.component.html',
  styleUrls: ['./editorial-link-list.component.scss'],
})
export class EditorialLinkListComponent {
  @Input() isMobile: boolean;
  @Input() editorialList: EditorialList;
  @Output() navigateTo = new EventEmitter<string>();
  @Output() menuClosed = new EventEmitter<null>();

  constructor(private applicationEventService: ApplicationEventService) {}

  onLinkClick(): void {
    this.menuClosed.emit();
  }

  fireEditorialLinkNavigationClickEvent(link: string): void {
    this.applicationEventService.publish(new EditorialLinkNavigationClickApplicationEvent(link));
  }

  onNavigate(link: string): void {
    this.navigateTo.emit(link);
    this.fireEditorialLinkNavigationClickEvent(link);
  }
}
